const PATH = "/api/v1/places";

const ENDPOINTS = {
  PLACES_LOCATIONS: "/locations/",
};

export type PlacesEndpoints = keyof typeof ENDPOINTS;
export const PlacesCollection = { PATH, ENDPOINTS };
